import tw from "twin.macro";

export const SectionHeading = tw.h2`text-4xl sm:text-5xl font-black tracking-wide text-center text-red-600`
export const Subheading = tw.h5`font-bold text-primary-500`
